import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { UtilsService } from "./services/utils.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  isUpdatesAvailable = false;

  constructor(
    private router: Router,
    private _utilsService: UtilsService // private _versionsService: VersionsService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this._utilsService.triggerViewContent();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    // const currentVersion = environment.version;
    // const latestVersion = await this._versionsService.getLatestVersions();
    // const platform = (window as any).require('electron-platform');
    // if (platform.isDarwin)
    // {
    //   this.isUpdatesAvailable = semver.lt(currentVersion, latestVersion.mac);
    // }
    // else if (platform.isWin32)
    // {
    //   this.isUpdatesAvailable = semver.lt(currentVersion, latestVersion.win);
    // }
    // this.router.navigate(["/efax/dashboard"]);
    // const ipcRenderer = (window as any).require("electron").ipcRenderer;
    // ipcRenderer.on("goto-guides", () => {
    //   this.router.navigate(["resources/guides"]);
    //   ipcRenderer.send("page-nav-complete");
    // });
  }
}
